<template>
    <div @click="gotoDetail()" class="subscription_item">
        <img :src="menuImage" class="subscription_image" />
    </div>
</template>

<script>
//vuex
import { mapActions } from 'vuex';

export default {
    name: "MenuItem",
    props: {
        index: Number,
        campaign: Object
    },
    data() {
        return {
            menuImage: null
        };
    },
    created: function() {
        this.init();
    },
    
    methods: {
        ...mapActions(["setCampaignSubscription"]),
        init() {
            this.menuImage = this.campaign.image_url;
        },
        gotoDetail() {
            this.setCampaignSubscription({
                campaign: this.campaign
            });
            this.$router.push("subscriptiondetail/" + this.campaign.id);
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/module/menu/style/menuItem.scss";
.subscription_item {
    margin-bottom: 15px;
    .subscription_image {
        height: 160px;
    }
}
</style>
